import { Id } from "@dgs/core";
import { FC, useEffect } from "react";
import { useRegistrationForm } from "../../registration/provider/registrationFormProviderContext";
import { RenderBlock } from "../../registration/RenderRegistrationBlock";
import { TextPage } from "./TextPage";

interface Props {
	blockId: Id | null;
	headline: string;
	text: string;
}

export const RegistrationDefaultEndPage: FC<Props> = ({ blockId, headline, text }) => {
	const { clearRegistration } = useRegistrationForm();

	useEffect(() => {
		clearRegistration();
	}, [clearRegistration]);

	if (blockId === null) {
		return <TextPage headline={headline} text={text} />;
	}

	return <RenderBlock blockId={blockId} />;
};
